import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import moment from 'moment'
import React from 'react'

class Publish extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    announcement: PropTypes.object
  }

  state = {
    config: {}
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { announcement } = this.props
    const { config } = this.state
    return {
      title: 't(Publish Agency Social Campaigns)',
      action: `/api/admin/truevail/admin/announcements/${announcement.id}/publish`,
      method: 'PATCH',
      saveText: 't(Publish)',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Publish At)', 
              type: 'segment', 
              fields: [
                { 
                  name: 'strategy', 
                  type: 'radiogroup', 
                  options: [
                    { value: 'now', text: 't(Publish immediately)' },
                    { value: 'schedule', text: 't(Schedule publish)' }
                  ], 
                  required: true, 
                  defaultValue: 'now' 
                },
                { 
                  name: 'publish_at', 
                  type: 'datetimefield', 
                  show: config.strategy === 'schedule', 
                  required: true,
                  defaultValue: moment()
                }
              ] 
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Publish